// i18n
import { useTranslation } from 'react-i18next';

// ui
import { Checkbox, CheckboxProps } from '../Checkbox/Checkbox';

// theme
import { theme } from '../../../theme';

// props
export interface CheckboxConfirmationProps extends CheckboxProps {
	formId: string;
}

export const CheckboxConfirmation = ({ formId, ...props }: CheckboxConfirmationProps) => {
	// hooks
	const { t } = useTranslation();

	return (
		<Checkbox
			helperText={t('form.confirmation.helper')}
			id={`${formId}-confirmation`}
			label={t('form.confirmation.label')}
			name="confirmation"
			required={true}
			sxBox={{
				padding: theme.spacing(2),
			}}
			{...props}
		/>
	);
};
